@if (loggedIn && !isParentPortal) {
<div>
  <app-changelog></app-changelog>
</div>
}

@if (!isNewTemplate) {
<div class="navbar">
  <a routerLink="{{ homepageLink }}" [ngClass]="{ 'disable': disableLogo, 'margin-left-logo': isNewTemplate }"><img
      [src]="logoPath" class="logo" /></a>
  @if (!loggedIn && btnNotInLoginPage) {
  <button type="submit" class="d-block d-xl-none outline btn-signin" (click)="getVisibility()">
    {{ btnLoginText }}
  </button>
  }
  @if (isNewTemplate && isParentPortal) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Parent_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (isNewTemplate && isClassSessionPortal && !loggedIn) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Self_Compoletion_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (isNewTemplate && isPublicSelfPortal && !loggedIn) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Public_Self_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (loggedIn && isMobile) {
  <mat-icon class="menu-icon notification" aria-hidden="false" (click)="changeUserCornerVisibility()">
    menu
    @if (totalCount > 0 && isNotificationVisible) {
    <div class="custom-badge">{{totalCount}}</div>
    }
  </mat-icon>
  }
  @if (loggedIn) {
  <div class="user-corner">
    <div class="user-corner-container" [hidden]="isUserCornerHidden">
      @if (isNotificationVisible) {
      <mat-toolbar>
        <button mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="totalCount > 0 ? clickmenu : null">
          <mat-icon class="notification">
            notifications_none
            @if (totalCount > 0) {
            <div class="custom-badge">{{totalCount}}</div>
            }
          </mat-icon>
        </button>
      </mat-toolbar>
      }
      <mat-menu #clickmenu="matMenu" style="padding-top: 15px; max-width: 420px !important;">
        <div style="padding-top: 15px; max-width: 420px !important;">
          @for (message of messageList; track message) {
          <button mat-menu-item (click)="clickMenuItem(message)" style="margin-bottom:5px; height: auto">
            <div class="row" style="line-height: initial; margin: 2px 2px 2px 2px;">
              <div class="col-7 col-xs-7 col-sm-7 col-md-7">
                <div class="row">
                  <div class="col-sm-12 col-md-12" style="font-size: 12px; font-weight: bold;  padding-left: 0px; overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;">
                    <span>{{ 'Display_Re' | resourcekey }} {{message.childFullName }}</span>
                  </div>
                  <div class="col-sm-12 col-md-12" style="font-size: 9px;  padding-left: 0px;">
                    <span>
                      {{ 'Display_SentOn' | resourcekey }}
                      {{message.sharedDocumentSource.createdOnString}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-5 col-xs-5 col-sm-5 col-md-5" style="overflow:hidden;  padding-right: 0px;">
                <img mat-card-sm-image style="width: auto; max-width: 99%; max-height: 30px; float:right;"
                  class="notificationItem" src="{{message.tenantLogo}}" alt="Client Logo">
              </div>
            </div>
            <div class="row" style="font-size: 10px; line-height: initial;">
              <div class="col-sm-12 col-md-12" style="overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap; margin-left: 2px;">
                <span> {{message.sharedDocumentSource.sharedDocument.title}} </span>
              </div>
            </div>
            <mat-divider style="margin-top: 2px;"></mat-divider>
          </button>
          }
        </div>
      </mat-menu>
      <button mat-flat-button [matMenuTriggerFor]="!isClassSessionPortal ? menu : null" matTooltip="{{ email }}">
        {{
        'Common_Hi' | resourcekey
        }}, {{ userName }}
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="userProfile()">{{ 'Common_UserProfile' | resourcekey }}</button>
        @if (isSessionBookingEnabled) {
        <button mat-menu-item [routerLink]="['/booking-calendar']">
          {{ 'Common_BookingCalendar' | resourcekey }}
        </button>
        }
        <button mat-menu-item (click)="logout()">{{ 'Common_Logout' | resourcekey }}</button>
      </mat-menu>
      @if (isAdminView) {
      <button [routerLink]="['/children']" mat-mini-fab color="primary" class="back-btn">
        <mat-icon class="material-icons">chevron_left</mat-icon>
      </button>
      }
      @if (isAdminButtonVisible) {
      <button mat-raised-button [matMenuTriggerFor]="adminMenu" class="admin-button">
        {{ 'Common_Admin' | resourcekey }}
      </button>
      }
      <mat-menu #adminMenu="matMenu">
        <button mat-menu-item [routerLink]="['admin/kpi']">
          <mat-icon>bar_chart</mat-icon>
          <span>{{ "Common_Kpi" | resourcekey }}</span>
        </button>
        <!-- <button mat-menu-item [routerLink]="['admin/schools']" class="no-outline">
          <mat-icon>menu</mat-icon>
          <span>{{ "Common_Schools" | resourcekey }}</span>
        </button>
         <button mat-menu-item [routerLink]="['admin/childrenImport']" class="no-outline">
          <mat-icon>menu</mat-icon>
          <span>{{ "ChildrenPageImportChildren" | resourcekey }}</span>
        </button> -->
        <!-- <button mat-menu-item [routerLink]="['admin/reports']">
          <mat-icon>format_list_numbered</mat-icon>
          <span>{{ "Common_Reports" | resourcekey }}</span>
        </button> -->
        <!-- <button mat-menu-item [routerLink]="['admin/dashboard']">
          <mat-icon>bar_chart</mat-icon>
          <span>{{ "Common_Dashboard" | resourcekey }}</span>
        </button> -->
        <!-- <button mat-menu-item [routerLink]="['admin/users']">
          <mat-icon>group_add</mat-icon>
          <span>{{ "Account_Users" | resourcekey }}</span>
        </button> -->
         @if (isSessionBookingEnabled) {
         <button mat-menu-item [routerLink]="['admin/staffAvailability']" class="no-outline">
          <mat-icon>menu</mat-icon>
          <span>{{ "Staff_Availability" | resourcekey }}</span>
        </button>
        <button mat-menu-item [routerLink]="['admin/bookingRequestManagement']" class="no-outline">
          <mat-icon>event_available</mat-icon>
          <span>{{ "Booking_Request_Management" | resourcekey }}</span>
        </button>
        }
      </mat-menu>
      <button mat-raised-button color="primary" (click)="logout()" class="logout-button">
        {{ 'Common_Logout' | resourcekey }}
      </button>
    </div>
  </div>
  }
</div>
}
@if (isNewTemplate) {
<div class="navbar navbar-parent">
  <a routerLink="{{ homepageLink }}" [ngClass]="{ 'disable': disableLogo }" class="margin-left-logo">
    <img [src]="logoPath" class="logo" />
  </a>
  @if (!loggedIn && btnNotInLoginPage) {
  <button type="submit" class="d-block d-xl-none outline btn-signin" (click)="getVisibility()">
    {{ btnLoginText }}
  </button>
  }
  @if (isParentPortal && !loggedIn) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Parent_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (isClassSessionPortal && !loggedIn) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Self_Compoletion_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (isPublicSelfPortal && !loggedIn) {
  <div class="parent-portal-title-div">
    <mat-label class="parent-portal-title"> {{'Public_Self_Portal' | resourcekey }}</mat-label>
  </div>
  }
  @if (isSessionBookingPortal && !loggedIn) {
  <div class="parent-portal-title-div session-booking-portal-title-div">
    <mat-label class="parent-portal-title session-booking-portal-title"> {{'Session_Booking_Campaign_Portal' |
      resourcekey }}</mat-label>
  </div>
  }
  @if (!isMobile && loggedIn && disableLogo) {
  <div class="mat-tab-container">
    <mat-tab-group [(selectedIndex)]="selectedHeaderTabIndex" animationDuration="0ms"
      (selectedTabChange)="tabChanged($event)">
      <mat-tab label="{{ 'Common_Forms' | resourcekey }}"> </mat-tab>
      <mat-tab label="{{ 'Common_Inbox' | resourcekey }}">
        <ng-template mat-tab-label>
          <div style="position: relative; display: flex; align-items: center;">
            <mat-icon class="inbox-tab-icon">
              mail_outline
            </mat-icon>
            {{ 'Common_Inbox' | resourcekey }}
            @if (totalCount > 0) {
            <div class="custom-badge">{{totalCount}}</div>
            }
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  }
  @if (loggedIn) {
  <div class="user-corner">
    @if (isMobile) {
    <div class="menu-icon-container" style="position: relative;">
      <mat-icon class="menu-icon notification" aria-hidden="false"
        [matMenuTriggerFor]="!isClassSessionPortal ? menu : null">
        menu
      </mat-icon>
      @if (totalCount > 0) {
      <span class="custom-badge">{{totalCount}}</span>
      }
    </div>
    }
    @if (!isMobile) {
    <button class="menu-button-web" aria-hidden="false" [matMenuTriggerFor]="!isClassSessionPortal ? menu : null">
      <span class="username-text"> {{ userName }} </span>
      <mat-icon class="menu-icon-web">menu</mat-icon>
    </button>
    }
    <div class="user-corner-container-new">
      <!-- <mat-toolbar *ngIf="isNotificationVisible">
            <button mat-icon-button (click)="goToInbox()">
              <mat-icon class="notification" matBadge={{totalCount}} matBadgeColor="warn">notifications_none
              </mat-icon>
            </button>
          </mat-toolbar> -->
      <!-- <button mat-flat-button [matMenuTriggerFor]="!isClassSessionPortal ? menu : null" matTooltip="{{ email }}"> {{
        'Common_Hi' | resourcekey }}, {{ userName }} </button> -->
      <mat-menu #menu="matMenu" class="mat-menu-group">
        <div class="mat-menu-container">
          @if (isParentPortal && isMobile) {
          <div class="inbox-menu-item" mat-menu-item>
            <button matTooltip="{{ email }}">
              <mat-icon> sentiment_satisfied_alt</mat-icon>
              <b>{{'Common_Hi' | resourcekey }}, {{ userName }} </b>
            </button>
          </div>
          }
          <mat-divider class="divider"></mat-divider>
          @if (isParentPortal && isMobile) {
          <div class="inbox-menu-item" mat-menu-item (click)="goToForms()">
            <button>
              <mat-icon>filter_none</mat-icon>
              {{ 'Common_Forms' | resourcekey }}
            </button>
          </div>
          }
          @if (isParentPortal && isMobile) {
          <div class="inbox-menu-item" mat-menu-item (click)="goToInbox()">
            <button>
              <div class="inbox-content">
                <mat-icon>mail_outline</mat-icon>
                <span>{{ 'Common_Inbox' | resourcekey }}</span>
                <div class="unread-messages-count">{{totalCount}}</div>
              </div>
            </button>
          </div>
          }
          <div class="inbox-menu-item" mat-menu-item (click)="userProfile()">
            <button>
              <mat-icon fontIcon="home"></mat-icon>
              {{ 'Common_UserProfile' | resourcekey }}
            </button>
          </div>
          <div class="inbox-menu-item" mat-menu-item (click)="logout()">
            <button>
              <mat-icon>power_settings_new</mat-icon>
              {{ 'Common_Logout' | resourcekey }}
            </button>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>
  }
</div>
}